import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
// // hooks/useApplyFilterAction.ts
import { useCopilotAction, useCopilotReadable, useCopilotAdditionalInstructions } from "@copilotkit/react-core";
import { useRef, useEffect, useState } from "react";
import { get, isEmpty } from "lodash";
import { useRouter } from "next/router";
import useShareLink from "../../../PatientSharing/services/useShareLink";
import { formatFiltersObj } from "../../../SearchFilters/utils";
import constants from "../../../../utils/constants";
import { useStoreState } from "pullstate";
import Store from "../../../../utils/Store";
import { trackEvent } from "../../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../../utils/mixpanelEvents";
import PatientList from "../../PatientList";
import SharePatients from "../../SharePatients";
import { useAuth } from "@qure/qure-auth";
var useApplyFilterActionWithAI = function useApplyFilterActionWithAI(applyFilters, filtersData, onChange, patients, sitesOptions, patientsCount, isDisabled, isLoading) {
  var _router$query, _router$query2;
  var _useState = useState("null"),
    lastSearch = _useState[0],
    setLastSearch = _useState[1];
  useCopilotAdditionalInstructions({
    instructions: "\n    NEVER EVER SHOW THE LIST OF PATIENTS IN THE RESPONSE OR ANY DETAILS ABOUT THE PATIENTS.\n    Always clear all the filters before applying new filters.\n",
    available: isDisabled ? "disabled" : "enabled"
  });
  useCopilotAdditionalInstructions({
    instructions: "\n    When the user asks to share a patient or a patient link it uses 'sharePatientLink' action here the input is the name of the patient user wants to share.\n    It does not matter if the patient exixts in current 'patients' context or not, the 'shareLinkPatient' takes the patient name, does the processing inside handler and then returns an appropriate respone.",
    available: isDisabled ? "disabled" : "enabled"
  });
  var findingsMappings = {
    nodule: "Nodule",
    tuberculosis: "Tuberculosis",
    ribfracture: "Rib Fracture",
    atelectasis: "Atelectasis",
    calcification: "Calcification",
    cavity: "Cavity",
    consolidation: "Consolidation",
    fibrosis: "Fibrosis",
    opacity: "Opacity",
    reticulonodularpattern: "Reticulonodularpattern",
    lung_nodule_malignancy: "Malignancy Risk",
    pneumothorax: "Pneumothorax",
    peffusion: "Pleural Effusion",
    bluntedcp: "Blunted Costophrenic Angle",
    hilarlymphadenopathy: "Hilar Enlargement",
    trachealshift: "Tracheal Shift",
    cardiomegaly: "Cardiomegaly",
    diaphragm: "Diaphragm",
    pneumoperitoneum: "Pneumoperitoneum",
    scoliosis: "Scoliosis",
    clavicle_fracture: "Clavicle Fracture",
    qmsk_fracture: "MSK Fracture",
    INFARCT: "Infarct",
    MCA_LVO: "MCA LVO",
    ICA_LVO: "ICA LVO",
    ICH: "Intracranial Hemorrhage",
    IPH: "Intraparenchymal Hemorrhage",
    SDH: "Subdural Hemorrhage",
    IVH: "Intraventricular Hemorrhage",
    SAH: "Subarachnoid Hemorrhage",
    EDH: "Extradural Hemorrhage",
    ME: "Mass Effect",
    MLS: "MidLine Shift",
    FRACTURE: "Cranial Fracture",
    ATROPHY: "Diffuse Cerebral Atrophy"
  };
  var demographicMappings = {
    "61_to_max": "> 60 years",
    "46_to_60": "46 to 60 years",
    "31_to_45": "31 to 45 years",
    "15_to_30": "15 to 30 years",
    min_to_14: "< 15 years",
    female: "female gender",
    male: "male gender",
    other: "other gender"
  };
  var modalityMappings = {
    mr: "MRI",
    ct: "CT",
    cr: "CR/CX/DR/DX"
  };
  var reportStatusMapping = {
    edited: "Edited",
    pending: "Pending",
    ai_report: "AI Report"
  };
  var questionnaireMapping = {
    patient_did_not_pickup_call: "Call Pending"
  };
  var scanStatusMapping = {
    positive: "Positive",
    negative: "Negative",
    pending: "Pending"
  };
  var filtersDataRef = useRef(filtersData);
  useEffect(function () {
    filtersDataRef.current = filtersData;
  }, [filtersData]);
  useCopilotReadable({
    description: new Date().toISOString().split("T")[0],
    value: "today",
    available: isDisabled ? "disabled" : "enabled"
  });
  useCopilotAdditionalInstructions({
    instructions: "\n  For filtering and searching keep in mind these extra instructions-\n  User can ask for a complex query, in this case look at all the filter options and you can apply multiple filters at once but all the options should only be the enums, they should not be some arbitrary values that are not in the enums.\n  If user asks for abnormal patients it means scan status is positive.\n  If user asks for normal patients it means scan status is negative.\n  If user asks for pending patients it means scan status is pending.\n  If user asks for patients with some finding positive it means present_findings has that finding and for negative it means absent_findings has that finding.\n  User might ask for List patients, get patients, give me patients, all means filtering of the patients.\n  when users clear or reset or remove, it means remove applied filter and bring it to default state, so apply it accordingly\n  ",
    available: isDisabled ? "disabled" : "enabled"
  });
  useCopilotAdditionalInstructions({
    instructions: "\n    If user asks how do i share this patient, use the 'sharePatientLink' action.\n    ",
    available: isDisabled ? "disabled" : "enabled"
  });
  var patientsRef = useRef(patients);
  useEffect(function () {
    patientsRef.current = patients;
    patientsCountRef.current = patientsCount;
  }, [patients, patientsCount]);
  var isLoadingRef = useRef(isLoading);
  useEffect(function () {
    isLoadingRef.current = isLoading;
  }, [isLoading]);
  useCopilotAction({
    name: "applyFilter",
    description: "Filter patients by applying filters",
    available: isDisabled ? "disabled" : "enabled",
    parameters: [{
      name: "present_findings",
      type: "string[]",
      description: "List of present findings in the patient (e.g. 'SAH', 'fever'). " + "A finding cannot be in both present_findings and absent_findings. " + "Descriptions for available options are provided in the 'findingsMappings' context." + "See 'filtersData' for context. You have to add to the previous context not replace it" + "The valid options are ".concat(Object.keys(findingsMappings).join(", ")) + "User will always provide the finding in natural language so you have to map it to the key value using the 'findingsMappings' context",
      "enum": Object.keys(findingsMappings)
    }, {
      name: "absent_findings",
      type: "string[]",
      description: "List of absent findings. Cannot include findings that are present. " + "If a finding exists in present_findings, remove it. " + "See 'findingsMappings' in context for options and descriptions. The key values of the 'findingsMappings' only can be the valid option" + "See 'filtersData' for context. You have to add to the previous context not replace it" + "The valid options are ".concat(Object.keys(findingsMappings).join(", ")) + "User will always provide the finding in natural language so you have to map it to the key value using the 'findingsMappings' context",
      "enum": Object.keys(findingsMappings)
    }, {
      name: "dateRange",
      type: "string[]",
      description: "The date range to filter the patients. There always has to be a start date and end date present.If user does not ask for any date related query keep start date and end date as 'null', " + "dates should be formatted in a recognizable way, such as 'March 5, 2023'. If only one date is provided, use it as both the start and end date. If someone says last week or last year then calculate the dates accordingly. " + "If the year is not specified in the date, assume the current year. Always understand, date is presented in DD/MM/YYYY or DD/MM/YY"
    }, {
      name: "modalities",
      type: "string[]",
      description: "The imaging modalities used to filter patients. " + "Only the keys from 'modalityMappings' in context are valid input values. " + "You can interpret natural terms like 'MRI' or 'CT scan' using the mapping, but only the corresponding keys (like 'mr', 'ct') should be used in the action. " + "When updating this filter, make sure to add to the existing filters in 'filtersData' and not replace them." + "The valid options are ".concat(Object.keys(modalityMappings).join(", ")) + "User will always provide the modality in natural language so you have to map it to the key value using the 'modalityMappings' context",
      "enum": Object.keys(modalityMappings)
    }, {
      name: "patient_type",
      type: "string[]",
      description: "Patient gender and age group filter. The only valid input values are the keys from 'demographicMappings' context. " + "You may interpret natural language like '> 60 years' or 'female' by mapping them to their corresponding keys like '61_to_max' and 'female'. " + "Use only the keys when calling this action. You can include multiple values. When applying this filter, do not override existing context in 'filtersData' — add to it." + "The valid options are ".concat(Object.keys(demographicMappings).join(", ")) + "User will always provide the patient type in natural language so you have to map it to the key value using the 'demographicMappings' context",
      "enum": Object.keys(demographicMappings)
    }, {
      name: "questionnaire_response",
      type: "string[]",
      description: "The questionnaire response used to filter patients. " + "Only the keys from 'questionnaireMapping' in context are valid values for this field. " + "You may interpret natural phrases like 'actions pending' using the corresponding key. " + "Use only those key values in the action. " + "When updating this field, add to the existing filters in 'filtersData' — do not replace them." + "The valid options are ".concat(Object.keys(questionnaireMapping).join(", ")) + "User will always provide the questionnaire response in natural language so you have to map it to the key value using the 'questionnaireMapping' context",
      "enum": Object.keys(questionnaireMapping)
    }, {
      name: "report_status",
      type: "string[]",
      description: "The report status used to filter patients. " + "Valid input values are the keys from 'reportStatusMapping' provided in context. " + "You may use the label values to understand user input (e.g., 'edited' or 'AI report'), " + "but convert them to their corresponding keys before applying the filter. " + "Do not replace existing filters in 'filtersData' — only add to them." + "The valid options are ".concat(Object.keys(reportStatusMapping).join(", ")) + "User will always provide the report status in natural language so you have to map it to the key value using the 'reportStatusMapping' context",
      "enum": Object.keys(reportStatusMapping)
    }, {
      name: "site",
      type: "string[]",
      description: "The site to filter the patients" + "See 'filtersData' for context. You have to add to the previous context not replace it" + "The valid options are ".concat(Object.values(sitesOptions).join(", ")) + "User will always provide the site in natural language so you have to map it to the key value using the 'sitesOptions' context" + "Whatever value user gives as input will be used as site do not assue anything.",
      "enum": Object.values(sitesOptions)
    }, {
      name: "dicom_upload",
      type: "string[]",
      description: "The scan status to filter the patients" + "See 'scanStatusMapping' in context for options and descriptions. The key values of the 'scanStatusMapping' only can be the valid option" + "See 'filtersData' for context. You have to add to the previous context not replace it" + "The valid options are ".concat(Object.keys(scanStatusMapping).join(", ")) + "User will always provide the scan status in natural language so you have to map it to the key value using the 'scanStatusMapping' context",
      "enum": Object.keys(scanStatusMapping)
    }, {
      name: "report_edited_by",
      type: "string[]",
      description: "The report edited by to filter the patients" + "See 'filtersData' for context. You have to add to the previous context not replace it" + "The valid options are ".concat(Object.keys(filtersData).join(", ")) + "User will always provide the report edited by in natural language so you have to map it to the key value using the 'filtersData' context",
      "enum": get(filtersData, ["report_edited_by", "tags", "dropdownMenuTags"], [])
    }, {
      name: "search",
      type: "string",
      description: "\nUse this field to specify a patient search query, such as a patient name or identifier.\nIf the user mentions a new name (e.g., \"find Maria\", \"get John\"), use that name as the search value and clear any previous filters.\nOnly ignore this field if no patient name is mentioned at all and filters are matched directly.\n"
    }],
    handler: function () {
      var _handler = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
        var absent_findings, present_findings, dateRange, modalities, patient_type, questionnaire_response, report_status, site, dicom_upload, search, _patientsRef$current$, toTagStructure, toSiteStructure, toReportStatusStructure, toFindingsStructure, toDateStructure, sitesFound, validSite, transformed, clear, minDuration, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              absent_findings = _ref.absent_findings, present_findings = _ref.present_findings, dateRange = _ref.dateRange, modalities = _ref.modalities, patient_type = _ref.patient_type, questionnaire_response = _ref.questionnaire_response, report_status = _ref.report_status, site = _ref.site, dicom_upload = _ref.dicom_upload, search = _ref.search;
              _context.p = 1;
              Store.update(function (s) {
                s.selectedFilterPatientTool = true;
              });
              trackEvent(MIXPANEL_EVENTS.ASSISTANT_ACTION, {
                action: "applyFilter",
                absent_findings: absent_findings,
                present_findings: present_findings,
                dateRange: dateRange,
                modalities: modalities,
                patient_type: patient_type,
                questionnaire_response: questionnaire_response,
                report_status: report_status,
                site: site,
                dicom_upload: dicom_upload,
                search: search
              });
              toTagStructure = function toTagStructure() {
                var tagsArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                return {
                  tags: {
                    dropdownTags: [],
                    tags: tagsArray,
                    dropdownMenuTags: []
                  }
                };
              };
              toSiteStructure = function toSiteStructure() {
                var tagsArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                return {
                  tags: {
                    dropdownTags: [],
                    tags: [],
                    dropdownMenuTags: tagsArray.map(function (tag) {
                      var _Object$entries$find;
                      return ((_Object$entries$find = Object.entries(sitesOptions).find(function (_ref2) {
                        var _ref3 = _slicedToArray(_ref2, 2),
                          key = _ref3[0],
                          value = _ref3[1];
                        return value === tag;
                      })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[0]) || null;
                    })
                  }
                };
              };
              toReportStatusStructure = function toReportStatusStructure() {
                var tagsArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                return {
                  tags: {
                    dropdownTags: [],
                    tags: tagsArray,
                    dropdownMenuTags: []
                  }
                };
              };
              toFindingsStructure = function toFindingsStructure() {
                var tagsArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var join = arguments.length > 1 ? arguments[1] : undefined;
                return {
                  tags: {
                    dropdownTags: [],
                    tags: tagsArray,
                    dropdownMenuTags: {}
                  },
                  join: join
                };
              };
              toDateStructure = function toDateStructure() {
                var tagsArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                return [tagsArray[0] === "null" ? null : tagsArray && tagsArray[0] || null, tagsArray[1] === "null" ? null : tagsArray && tagsArray[1] || null];
              };
              sitesFound = site === null || site === void 0 ? void 0 : site.map(function (s) {
                var _Object$values;
                return (_Object$values = Object.values(sitesOptions)) === null || _Object$values === void 0 ? void 0 : _Object$values.find(function (value) {
                  return value === s;
                });
              });
              validSite = (sitesFound === null || sitesFound === void 0 ? void 0 : sitesFound.length) > 0 && sitesFound[0] === undefined;
              if (!((site === null || site === void 0 ? void 0 : site.length) > 0 && validSite)) {
                _context.n = 2;
                break;
              }
              return _context.a(2, {
                patientsCount: patientsCountRef.current,
                patients: [],
                clearFilters: false,
                displayMessage: "There exists no site with the name ".concat(site === null || site === void 0 ? void 0 : site.join(", "))
              });
            case 2:
              transformed = {
                // ...filtersData,
                absent_findings: toFindingsStructure(absent_findings, "and"),
                present_findings: toFindingsStructure(present_findings, "or"),
                dateRange: toDateStructure(dateRange),
                modalities: toTagStructure(modalities),
                patient_type: toTagStructure(patient_type),
                questionnaire_response: toTagStructure(questionnaire_response),
                report_status: toReportStatusStructure(report_status),
                site: toSiteStructure(sitesFound),
                dicom_upload: toTagStructure(dicom_upload)
              };
              clear = absent_findings.length === 0 && present_findings.length === 0 && (dateRange.length === 0 || dateRange.find(function (d) {
                return d !== "null" && d !== null;
              }) === undefined) && modalities.length === 0 && patient_type.length === 0 && questionnaire_response.length === 0 && report_status.length === 0 && site.length === 0 && dicom_upload.length === 0 && search === "";
              setLastSearch(search || "");
              applyFilters(transformed, search || "", clear);
              _context.n = 3;
              return Promise.race([new Promise(function (resolve) {
                var _check = function check() {
                  if (isLoadingRef.current) resolve("notLoading");else setTimeout(_check, 50); // check every 50ms
                };
                _check();
              }), new Promise(function (resolve) {
                return setTimeout(function () {
                  return resolve("timeout");
                }, 7000);
              })]);
            case 3:
              minDuration = new Promise(function (resolve) {
                return setTimeout(resolve, 2500);
              });
              _context.n = 4;
              return Promise.all([Promise.race([new Promise(function (resolve) {
                var _check2 = function check() {
                  if (!isLoadingRef.current) resolve("loadingFinished");else setTimeout(_check2, 50);
                };
                _check2();
              }), new Promise(function (resolve) {
                return setTimeout(function () {
                  return resolve("timeout");
                }, 10000);
              })]), minDuration]);
            case 4:
              onChange((_patientsRef$current$ = patientsRef.current[0]) === null || _patientsRef$current$ === void 0 ? void 0 : _patientsRef$current$.patient_uid);
              if (!clear) {
                _context.n = 5;
                break;
              }
              return _context.a(2, {
                patientsCount: patientsCountRef.current,
                patients: [],
                clearFilters: true
              });
            case 5:
              return _context.a(2, {
                patientsCount: patientsCountRef.current,
                patients: patientsRef.current.slice(0, 2).map(function (patient) {
                  var _patient$latest_study;
                  return {
                    name: patient.name,
                    patient_uid: patient.patient_uid,
                    patient_id: patient.patient_id,
                    age: patient.age,
                    gender: patient.gender,
                    site: patient.site,
                    modality: patient.modality,
                    workspace_display_name: patient.workspace_display_name,
                    created_at: patient === null || patient === void 0 ? void 0 : patient.created_at,
                    latest_study: {
                      thumbnail_url: (_patient$latest_study = patient.latest_study) === null || _patient$latest_study === void 0 ? void 0 : _patient$latest_study.thumbnail_url
                    }
                  };
                }),
                clearFilters: false
              });
            case 6:
              _context.p = 6;
              _t = _context.v;
              console.error("❌ Error in handler:", _t);
            case 7:
              return _context.a(2);
          }
        }, _callee, null, [[1, 6]]);
      }));
      function handler(_x) {
        return _handler.apply(this, arguments);
      }
      return handler;
    }(),
    followUp: false,
    render: function render(_ref4) {
      var args = _ref4.args,
        status = _ref4.status,
        result = _ref4.result;
      var isEmptyResult = result === null || result === void 0 ? void 0 : result.clearFilters;
      if (status === "complete") {
        return /*#__PURE__*/React.createElement(PatientList, {
          patients: result.patients,
          onChange: onChange,
          patientsCount: result.patientsCount,
          isClearFilter: isEmptyResult,
          displayMessage: (result === null || result === void 0 ? void 0 : result.displayMessage) || null
        });
      } else if ((status === "executing" || status === "inProgress") && !isEmptyResult) {
        return /*#__PURE__*/React.createElement("div", {
          className: "dark:text-gray-200"
        }, /*#__PURE__*/React.createElement("div", {
          className: "w-[80%] border dark:border-gray-700  border-gray-300 rounded-md rounded-tl-none shadow-md dark:bg-gray-800 bg-gray-500"
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex justify-between items-center space-x-1 mb-3 p-4 dark:bg-gray-800 bg-gray-500 rounded-t-md"
        }, /*#__PURE__*/React.createElement("div", {
          className: "h-6 w-24 dark:bg-gray-700 bg-gray-300 rounded-md animate-pulse"
        }), /*#__PURE__*/React.createElement("div", {
          className: "h-5 w-32 dark:bg-gray-700 bg-gray-300 rounded-md animate-pulse"
        })), /*#__PURE__*/React.createElement("div", {
          className: "dark:bg-gray-900 bg-gray-200 rounded-md overflow-hidden shadow-md"
        }, Array(2).fill(0).map(function (_, index) {
          return /*#__PURE__*/React.createElement("div", {
            key: index,
            className: "flex flex-col p-4 ".concat(index < 5 - 1 ? "border-b dark:border-gray-800 border-gray-300" : "")
          }, /*#__PURE__*/React.createElement("div", {
            className: "flex items-center justify-between"
          }, /*#__PURE__*/React.createElement("div", {
            className: "flex items-center gap-3"
          }, /*#__PURE__*/React.createElement("div", {
            className: "h-8 w-8 rounded-md dark:bg-gray-800 bg-gray-100 animate-pulse"
          }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            className: "h-5 w-32 dark:bg-gray-800 bg-gray-100 rounded-md animate-pulse mb-2"
          }), /*#__PURE__*/React.createElement("div", {
            className: "flex space-x-3"
          }, /*#__PURE__*/React.createElement("div", {
            className: "h-4 w-16 dark:bg-gray-800 bg-gray-100 rounded-md animate-pulse"
          }), /*#__PURE__*/React.createElement("div", {
            className: "h-4 w-24 dark:bg-gray-800 bg-gray-100 rounded-md animate-pulse"
          })))), /*#__PURE__*/React.createElement("div", {
            className: "h-6 w-6 rounded-md dark:bg-gray-800 bg-gray-100 animate-pulse"
          })), /*#__PURE__*/React.createElement("div", {
            className: "flex justify-end mt-2"
          }, /*#__PURE__*/React.createElement("div", {
            className: "h-3 w-40 dark:bg-gray-800 bg-gray-100 rounded-md animate-pulse"
          })));
        }))));
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
  });
  var _useState2 = useState(null),
    results = _useState2[0],
    setResults = _useState2[1];
  var _useState3 = useState(false),
    copyStarted = _useState3[0],
    setCopyStarted = _useState3[1];
  var _useShareLink = useShareLink((results === null || results === void 0 ? void 0 : results.patient_uid) || "", !isEmpty(results) && !isDisabled),
    data = _useShareLink.data,
    isSuccess = _useShareLink.isSuccess,
    isCopyLoading = _useShareLink.isLoading;
  useEffect(function () {
    if (isSuccess && !isEmpty(data)) {
      var urlAuthToken = get(data, ["url_auth_token"], "");
      var shareURL = "".concat(window.location.origin, "/viewer/quredicom/").concat(results === null || results === void 0 ? void 0 : results.patient_uid, "?url_auth_token=").concat(urlAuthToken);
      if (copyStarted) {
        navigator.clipboard.writeText(shareURL);
        setTimeout(function () {
          setCopyStarted(false);
        }, 2000);
      }
    }
  }, [data, isSuccess, copyStarted]);
  var patientUID = useRef(null);
  var router = useRouter();
  var patientsCountRef = useRef(patientsCount);
  var id = router !== null && router !== void 0 && (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.params ? router === null || router === void 0 || (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.params[0] : null;
  var selectedPatient = useStoreState(Store, function (s) {
    return s.patientDetail;
  });
  var currentPatient = useRef(selectedPatient);
  var previousPatientsRef = useRef(undefined);
  useEffect(function () {
    previousPatientsRef.current = currentPatient.current;
    currentPatient.current = selectedPatient;
  }, [selectedPatient]);
  useCopilotAdditionalInstructions({
    instructions: "\n    If user does not speecify the patient name, whatever happens always select the currently selected patient from useCopilotReadable context.\n    ",
    available: isDisabled ? "disabled" : "enabled"
  });
  useCopilotAction({
    name: "sharePatientLink",
    available: isDisabled ? "disabled" : "enabled",
    followUp: false,
    description: "Shares a patient link. If no patient name is provided, send undefined as patientName. It is either the name that user gave or 'undefined'. NEVER TRY TO GUESS THE NAME.. If it throws an error then the link is not found",
    parameters: [{
      name: "patientName",
      description: "The name of the patient user wants to share",
      type: "string",
      required: false
    }],
    handler: function () {
      var _handler2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref5) {
        var _previousPatientsRef$, _previousPatientsRef$2, _selectedPatient$name;
        var patientName, hasPatientChanged, match, minDuration;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              patientName = _ref5.patientName;
              trackEvent(MIXPANEL_EVENTS.ASSISTANT_ACTION, {
                action: "sharePatientLink",
                patient_name: patientName
              });
              hasPatientChanged = (patientName === null || patientName === void 0 ? void 0 : patientName.toLowerCase().trim()) === ((_previousPatientsRef$ = previousPatientsRef.current) === null || _previousPatientsRef$ === void 0 || (_previousPatientsRef$ = _previousPatientsRef$.name) === null || _previousPatientsRef$ === void 0 ? void 0 : _previousPatientsRef$.toLowerCase().trim()) && (selectedPatient === null || selectedPatient === void 0 ? void 0 : selectedPatient.patient_uid) !== ((_previousPatientsRef$2 = previousPatientsRef.current) === null || _previousPatientsRef$2 === void 0 ? void 0 : _previousPatientsRef$2.patient_uid);
              if (!(selectedPatient !== null && selectedPatient !== void 0 && (_selectedPatient$name = selectedPatient.name) !== null && _selectedPatient$name !== void 0 && _selectedPatient$name.toLowerCase().trim().startsWith(patientName === null || patientName === void 0 ? void 0 : patientName.toLowerCase().trim()) || patientName === undefined || hasPatientChanged || patientName === null || patientName === "undefined")) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, selectedPatient);
            case 1:
              match = patientsRef.current.find(function (p) {
                var _p$name;
                return ((_p$name = p.name) === null || _p$name === void 0 ? void 0 : _p$name.toLowerCase().trim()) === (patientName === null || patientName === void 0 ? void 0 : patientName.toLowerCase().trim());
              });
              if (!match) {
                _context2.n = 2;
                break;
              }
              router.push("/patients/".concat(match.patient_uid), undefined, {
                shallow: true
              });
              onChange(match.patient_uid);
              return _context2.a(2, match);
            case 2:
              applyFilters({}, patientName || "", false);
              _context2.n = 3;
              return Promise.race([new Promise(function (resolve) {
                var _check3 = function check() {
                  if (isLoadingRef.current) resolve("notLoading");else setTimeout(_check3, 50); // check every 50ms
                };
                _check3();
              }), new Promise(function (resolve) {
                return setTimeout(function () {
                  return resolve("timeout");
                }, 7000);
              })]);
            case 3:
              minDuration = new Promise(function (resolve) {
                return setTimeout(resolve, 2500);
              });
              _context2.n = 4;
              return Promise.all([Promise.race([new Promise(function (resolve) {
                var _check4 = function check() {
                  if (!isLoadingRef.current) resolve("loadingFinished");else setTimeout(_check4, 50);
                };
                _check4();
              }), new Promise(function (resolve) {
                return setTimeout(function () {
                  return resolve("timeout");
                }, 10000);
              })]), minDuration]);
            case 4:
              if (!(patientsRef.current.length > 0)) {
                _context2.n = 5;
                break;
              }
              patientUID.current = patientsRef.current[0].patient_uid || null;
              onChange(patientsRef.current[0].patient_uid);
              return _context2.a(2, patientsRef.current[0]);
            case 5:
              return _context2.a(2, null);
          }
        }, _callee2);
      }));
      function handler(_x2) {
        return _handler2.apply(this, arguments);
      }
      return handler;
    }(),
    render: function render(_ref6) {
      var args = _ref6.args,
        status = _ref6.status,
        result = _ref6.result;
      return /*#__PURE__*/React.createElement(SharePatients, {
        result: result,
        status: status,
        setCopyStarted: setCopyStarted,
        setResults: setResults,
        isCopyLoading: isCopyLoading
      });
    }
  });
};
export var useApplyFilterAction = function useApplyFilterAction(applyFilters, filtersData, onChange, patients, sitesOptions, patientsCount, isLoading) {
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        areFrontendToolsEnabled: s.areFrontendToolsEnabled
      };
    }),
    areFrontendToolsEnabled = _useStoreState.areFrontendToolsEnabled;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var isAIAssistantEnabled = get(userInfo, ["settings", "ui_settings", "ai_assistant"], false);
  var isDisabled = !isAIAssistantEnabled || !userInfo || !areFrontendToolsEnabled;
  return useApplyFilterActionWithAI(applyFilters, filtersData, onChange, patients, sitesOptions, patientsCount, isDisabled, isLoading);
};
var useApplySavedFilterActionWithAI = function useApplySavedFilterActionWithAI(setFilters, setSavedFilterData, filterLabel, patients, onChangePatient, userInfo, patientsCount, isDisabled, isLoading) {
  var filterList = get(userInfo, ["settings", "saved_filters"], []);
  var savedFilterList = filterList.map(function (item) {
    return {
      label: item.name,
      values: item.filter,
      id: item.id,
      is_default: item.is_default
    };
  });
  var isLoadingRef = useRef(isLoading);
  useEffect(function () {
    isLoadingRef.current = isLoading;
  }, [isLoading]);
  useCopilotAdditionalInstructions({
    instructions: "\n    The saved filter applied currently can be found from filters.data.label context.\n    Always call the handler function even if the saved filter is already applied.\n    ",
    available: isDisabled ? "disabled" : "enabled"
  });
  var patientsRef = useRef(patients);
  var patientsCountRef = useRef(patientsCount);
  useEffect(function () {
    patientsRef.current = patients;
    patientsCountRef.current = patientsCount;
  }, [patients, patientsCount]);
  useCopilotAction({
    name: "applySavedFilter",
    description: "Apply a saved filter",
    available: isDisabled ? "disabled" : "enabled",
    parameters: [{
      name: "savedFilterLabel",
      type: "string",
      description: "The label of the saved filter to apply",
      "enum": savedFilterList.map(function (filter) {
        return filter.label;
      })
    }],
    handler: function () {
      var _handler3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref7) {
        var savedFilterLabel, handleSingleTagchange, savedFilter, minDuration;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              savedFilterLabel = _ref7.savedFilterLabel;
              trackEvent(MIXPANEL_EVENTS.ASSISTANT_ACTION, {
                action: "applySavedFilter",
                filter_label: savedFilterLabel
              });
              handleSingleTagchange = function handleSingleTagchange(item) {
                Store.update(function (s) {
                  s.selectedFilterPatientTool = true;
                });
                var label = item.label,
                  values = item.values,
                  id = item.id;
                var formattedFilters = formatFiltersObj(values);
                var appliedFilter = {
                  isFilterApplied: true,
                  label: label,
                  data: formattedFilters,
                  id: id
                };
                setFilters(appliedFilter);
                setSavedFilterData(values);
                localStorage.setItem(constants.PERSISTED.filterObj, JSON.stringify(appliedFilter));
                localStorage.setItem(constants.PERSISTED.savedFilterData, JSON.stringify(values));
              };
              savedFilter = savedFilterList.find(function (filter) {
                return filter.label === savedFilterLabel;
              });
              if (!savedFilter) {
                _context3.n = 2;
                break;
              }
              handleSingleTagchange(savedFilter);
              _context3.n = 1;
              return Promise.race([new Promise(function (resolve) {
                var _check5 = function check() {
                  if (isLoadingRef.current) resolve("notLoading");else setTimeout(_check5, 50); // check every 50ms
                };
                _check5();
              }), new Promise(function (resolve) {
                return setTimeout(function () {
                  return resolve("timeout");
                }, 7000);
              })]);
            case 1:
              minDuration = new Promise(function (resolve) {
                return setTimeout(resolve, 2500);
              });
              _context3.n = 2;
              return Promise.all([Promise.race([new Promise(function (resolve) {
                var _check6 = function check() {
                  if (!isLoadingRef.current) resolve("loadingFinished");else setTimeout(_check6, 50);
                };
                _check6();
              }), new Promise(function (resolve) {
                return setTimeout(function () {
                  return resolve("timeout");
                }, 10000);
              })]), minDuration]);
            case 2:
              return _context3.a(2, {
                patientsCount: patientsCountRef.current,
                patients: patientsRef.current.slice(0, 2).map(function (patient) {
                  var _patient$latest_study2;
                  return {
                    name: patient.name,
                    patient_uid: patient.patient_uid,
                    patient_id: patient.patient_id,
                    age: patient.age,
                    gender: patient.gender,
                    site: patient.site,
                    modality: patient.modality,
                    workspace_display_name: (patient === null || patient === void 0 ? void 0 : patient.workspace_display_name) || "",
                    created_at: patient === null || patient === void 0 ? void 0 : patient.created_at,
                    latest_study: {
                      thumbnail_url: (_patient$latest_study2 = patient.latest_study) === null || _patient$latest_study2 === void 0 ? void 0 : _patient$latest_study2.thumbnail_url
                    }
                  };
                })
              });
          }
        }, _callee3);
      }));
      function handler(_x3) {
        return _handler3.apply(this, arguments);
      }
      return handler;
    }(),
    followUp: false,
    render: function render(_ref8) {
      var args = _ref8.args,
        status = _ref8.status,
        result = _ref8.result;
      var isEmptyResult = Object.values(args).every(function (value) {
        if (Array.isArray(value)) {
          return value.length === 0 || value.every(function (v) {
            return v === null || v === "";
          });
        }
        return value === "" || value === null;
      });
      if (status === "complete") {
        return /*#__PURE__*/React.createElement(PatientList, {
          patients: result.patients,
          onChange: onChangePatient,
          patientsCount: result.patientsCount,
          isClearFilter: isEmptyResult
        });
      } else if (status === "executing" && !isEmptyResult) {
        return /*#__PURE__*/React.createElement("div", {
          className: "text-gray-200"
        }, /*#__PURE__*/React.createElement("div", {
          className: "w-[80%] rounded-md rounded-tl-none shadow-md"
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex justify-between items-center space-x-1 mb-3 p-4 dark:bg-gray-800 bg-gray-400 rounded-tr-md"
        }, /*#__PURE__*/React.createElement("div", {
          className: "h-6 w-24 dark:bg-gray-700 bg-gray-300 rounded-md animate-pulse"
        }), /*#__PURE__*/React.createElement("div", {
          className: "h-5 w-32 dark:bg-gray-700 bg-gray-300 rounded-md animate-pulse"
        })), /*#__PURE__*/React.createElement("div", {
          className: "dark:bg-gray-900 bg-gray-100 rounded-md overflow-hidden shadow-md"
        }, Array(2).fill(0).map(function (_, index) {
          return /*#__PURE__*/React.createElement("div", {
            key: index,
            className: "flex flex-col p-4 ".concat(index < 5 - 1 ? "border-b dark:border-gray-800 border-gray-300" : "")
          }, /*#__PURE__*/React.createElement("div", {
            className: "flex items-center justify-between"
          }, /*#__PURE__*/React.createElement("div", {
            className: "flex items-center gap-3"
          }, /*#__PURE__*/React.createElement("div", {
            className: "h-8 w-8 rounded-md dark:bg-gray-800 bg-gray-300 animate-pulse"
          }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            className: "h-5 w-32 dark:bg-gray-800 bg-gray-300 rounded-md animate-pulse mb-2"
          }), /*#__PURE__*/React.createElement("div", {
            className: "flex space-x-3"
          }, /*#__PURE__*/React.createElement("div", {
            className: "h-4 w-16 dark:bg-gray-800 bg-gray-300 rounded-md animate-pulse"
          }), /*#__PURE__*/React.createElement("div", {
            className: "h-4 w-24 dark:bg-gray-800 bg-gray-300 rounded-md animate-pulse"
          })))), /*#__PURE__*/React.createElement("div", {
            className: "h-6 w-6 rounded-md dark:bg-gray-800 bg-gray-300 animate-pulse"
          })), /*#__PURE__*/React.createElement("div", {
            className: "flex justify-end mt-2"
          }, /*#__PURE__*/React.createElement("div", {
            className: "h-3 w-40 dark:bg-gray-800 bg-gray-300 rounded-md animate-pulse"
          })));
        }))));
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
  });
};
export var useApplySavedFilterAction = function useApplySavedFilterAction(setFilters, setSavedFilterData, filterLabel, patients, onChangePatient, patientsCount, isLoading) {
  var _useAuth2 = useAuth(),
    userInfo = _useAuth2.userInfo;
  var _useStoreState2 = useStoreState(Store, function (s) {
      return {
        areFrontendToolsEnabled: s.areFrontendToolsEnabled
      };
    }),
    areFrontendToolsEnabled = _useStoreState2.areFrontendToolsEnabled;
  var isAIAssistantEnabled = get(userInfo, ["settings", "ui_settings", "ai_assistant"], false);
  var isDisabled = !isAIAssistantEnabled || !userInfo || !areFrontendToolsEnabled;
  return useApplySavedFilterActionWithAI(setFilters, setSavedFilterData, filterLabel, patients, onChangePatient, userInfo || null, patientsCount, isDisabled, isLoading);
};